import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { User } from "~/common/Store/models/User";
import rewardsCardImg from "./rewards-card.svg";
import getLowestDisplayPrice from "~/common/Product/getLowestDisplayPrice";
import { PricingGroupMember } from "./PricingProduct";

interface Product {
  customizationRequired: boolean;
  customizationUrl: string;
  isCustomizable: boolean;
  minimumCustomizationPrice: number;
  groupingAttributes: {
    isVirtual: boolean;
    isGroupMaster: boolean;
    groupMembers: PricingGroupMember[];
  };
  price: {
    displayMinimumAdvertisedPrice: boolean;
    displaySalePrice: boolean;
    saleStartDate?: string;
    saleEndDate?: string;
    salePrice: number;
    price: number;
    minimumAdvertisedPriceProperties: {
      price: number;
      type: string;
    };
    minimumAdvertisedPriceOverride: {
      priceLevel5: number;
    };
    quantityDiscounts: {
      endQuantity?: number;
      isLotDiscount: boolean;
      price: number;
      quantity: number;
      startQuantity: number;
    }[];
  };
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
  showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  showRewardsCardAd: boolean;
  startBuy: number;
}

interface Props {
  user: User;
  product: Product;
}

const RewardsCardAd = ({ user, product }: Props) => {
  const { showRewardsCardAd } = product;

  const isRewardsMember =
    user.index && user.index !== "0" && user.isRewardsMember;

  const lowestPrice = getLowestDisplayPrice(product, user, true);

  const dollarsBack = Number((lowestPrice * 0.03).toFixed(2));

  const points = Number((dollarsBack * 100).toFixed(0));

  return (
    <>
      {showRewardsCardAd && !isRewardsMember && (
        <div className="credit-card border-gray-200 border-solid border-r-0 border-b-0 border-l-0 border-t flex items-center justify-center pt-5 xs:pt-4 mb-1 md:-mb-1 md:mt-5">
          <img
            src={rewardsCardImg}
            alt="Webstaurant Rewards Visa Credit Card"
            height="23"
            width="35"
            aria-hidden
          />
          <p className="font-semibold text-sm leading-3 mb-0 ml-3">
            {`Earn up to ${formatAsCurrency.formatIfUndefined(
              dollarsBack,
            )} back `}
            <span className="text-2xs text-gray-600">
              ({points.toLocaleString("en-US")} points)
            </span>
            <span className="block font-normal text-2xs">
              {"with a "}
              <a
                href="/rewards/"
                className="underline"
                title="Webstaurant Rewards Visa Credit Card"
              >
                Webstaurant Rewards Visa&reg; Credit Card
              </a>
            </span>
          </p>
        </div>
      )}
    </>
  );
};

export default RewardsCardAd;
